import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReservationLogin } from "../Services/Service";

const Reservationlogin = () => {


  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const result = await ReservationLogin(email, password);
      console.log("Login API response:", result);
      if (result?.token) {

        localStorage.setItem("ReservationUsername", email);
        localStorage.setItem("ReservationPassword", password);
        localStorage.setItem("ReservationAuthToken", result.token);
        localStorage.setItem("authType", "reservation");
        console.log("ReservationAuthToken", result.token)

        navigate("/Reservation/NewBooking");
      } else {
        setError("Invalid login credentials");
      }
    } catch (err) {
      setError("Something went wrong. Try again.");
    } finally {
      setLoading(false); // Hide loader
    }
  };

  return (
    <>
      <style>
        {`
          .form-control{
            border-color: #D3D3D4 !important;
          }
            .text-danger{
                 color: #ff000d !important;
            }
           .input-error {
            border-color: red !important;
          }
        `}
      </style>

      {loading && (
        <div className="fullscreen-loader">
          <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
        </div>
      )}

      <div className="login-wrapper d-flex">
        {/* Left Panel */}
        <div className="login-left ">

          <h2 className="fw-bold ">Welcome back!</h2>
          <p className="text-muted mb-1 ">User Experience & Interface Design</p>
          <p className="text-muted ">Strategy SaaS Solutions</p>
          <img
            src="https://cdni.iconscout.com/illustration/premium/thumb/login-3305943-2757111.png"
            alt="login"
            className="img-fluid mt-5 "
            style={{ maxWidth: '220px' }}
          />
        </div>

        {/* Right Panel */}
        <div className="login-right">
          <div className="login-box w-100">
            <h3 className="text-center fw-bold mb-4">Sign in your Resevation account</h3>
            <form className="mt-3" onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="form-label">Username/Email</label>
                <input
                  type="text"
                  className={`form-control ${error ? "input-error" : ""}`}
                  placeholder="Enter your username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className={`form-control ${error ? "input-error" : ""}`}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="text-end mb-3">
                <a href="/Forgotpassword" className="text-primary">Forgot password?</a>
              </div>
              {/* Show error message if login fails */}
              {error && <div className="text-danger text-center">{error}</div>}
              <button type="submit" className="btn btn-primary w-100 fw-bold">Sign In</button>
            </form>

          </div>
        </div>
      </div>



    </>
  );
};

export default Reservationlogin;
